export const MODULES = {
  CARGOMATE: 'cargomate',
  ROB: 'rob',
}
